import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Table } from 'semantic-ui-react';
import BannerImg from '../../../../public/assets/images/BannersFiles/27.jpg';
import StaticBanner from '../../../components/elements/StaticBanner';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-use';

const Ouroffices = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();
  const { pathname } = useLocation();
  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);

  return (
    <>
      <StaticBanner BannerImg={ BannerImg } en_US={ 'Our Offices' } arabic={ false } />
      <div className="py-5">
        <section className={ `h-90  px-3 lg:px-12 text-center` }>
          {/* <img src={`public/img/logo.png`} className="pb-4" alt="" /> */ }

          <h2 className={ `text-customgreen sm:text-4xl flex font-bold py-6 justify-center  ` } >
            { ' ' }
            { t('Headquarters') }
          </h2>

          <div className="relative overflow-x-auto  shadow-md sm:rounded-lg" >
            <Table className="text-sm text-left rtl:text-right ">
              <Table.Header className="text-xs text-white bg-customgreen uppercase whitespace-nowrap">
                <Table.Row>
                  <Table.HeaderCell className="text-white">{ t('Toll-Free Number') }</Table.HeaderCell>
                  <Table.HeaderCell className="text-white">{ t('Email') }</Table.HeaderCell>

                  <Table.HeaderCell className="text-white">{ t('Address') }</Table.HeaderCell>
                  <Table.HeaderCell className="text-white">{ t('Geographic') }</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row className="align-middle">
                  <Table.Cell verticalAlign="bottom">80014</Table.Cell>
                  <Table.Cell>info@shjc.sharjah.ae</Table.Cell>
                  <Table.Cell>شارع الشيخ راشد بن صقر القاسمي , سمنان, الشارقة</Table.Cell>
                  <Table.Cell>
                    { ' ' }
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7211.643604819746!2d55.4197221!3d25.34376!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f596bf84d56a1%3A0x1f560b9dcfdaecfb!2sSharjah%20Charity%20International!5e0!3m2!1sen!2s!4v1718172088727!5m2!1sen!2s"
                      className="rounded-2xl w-full"
                      height="250"
                      allowfullscreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>

          <h2 className={ `text-customgreen  sm:text-4xl flex font-bold py-6 justify-center ` } >
            { t('Kalba Branch') }
          </h2>
          <div className="relative overflow-x-auto  shadow-md sm:rounded-lg" >
            <Table className="text-sm text-left rtl:text-right ">
              <Table.Header className="text-xs text-white bg-customgreen uppercase  whitespace-nowrap">
                <Table.Row>
                  <Table.HeaderCell className="text-white">{ t('Toll-Free Number') }</Table.HeaderCell>
                  <Table.HeaderCell className="text-white">{ t('Geographic') }</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row className="align-middle">
                  <Table.Cell>80014</Table.Cell>
                  <Table.Cell>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d462083.7324900204!2d55.5525516!3d25.2022391!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef4fa29ea4bc5b1%3A0xa7c2fc2dd8577736!2sSharjah%20Charity%20International%20-%20Kalba!5e0!3m2!1sen!2s!4v1718176295788!5m2!1sen!2s"
                      className="rounded-2xl w-full"
                      height="250"
                      allowfullscreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>

          <h2 className={ `text-customgreen sm:text-4xl flex font-bold py-6 justify-center ` } >
            { t('Khor Fakkan Branch') }{ ' ' }
          </h2>
          <div className="relative overflow-x-auto  shadow-md sm:rounded-lg" >
            <Table className="text-sm text-left rtl:text-right ">
              <Table.Header className="text-xs text-white bg-customgreen uppercase  whitespace-nowrap">
                <Table.Row>
                  <Table.HeaderCell className="text-white">{ t('Toll-Free Number') }</Table.HeaderCell>
                  <Table.HeaderCell className="text-white">{ t('Geographic') }</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row className="align-middle">
                  <Table.Cell>80014</Table.Cell>
                  <Table.Cell>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3606.286064449762!2d56.344912!3d25.328180099999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef44fc91310388f%3A0xafae08ec6fda6245!2sSharjah%20Charity%20International!5e0!3m2!1sen!2s!4v1718176267650!5m2!1sen!2s"
                      className="rounded-2xl w-full"
                      height="250"
                      allowfullscreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>

          <h2 className={ `text-customgreen  sm:text-4xl flex font-bold py-6 justify-center ` } >
            { t('Dibba Al-Hisn Branch') }
          </h2>

          <div className="relative overflow-x-auto  shadow-md sm:rounded-lg" >
            <Table className="text-sm text-left rtl:text-right ">
              <Table.Header className="text-xs text-white bg-customgreen uppercase  whitespace-nowrap">
                <Table.Row>
                  <Table.HeaderCell className="text-white">{ t('Toll-Free Number') }</Table.HeaderCell>
                  <Table.HeaderCell className="text-white">{ t('Geographic') }</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row className="align-middle">
                  <Table.Cell>80014</Table.Cell>
                  <Table.Cell>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3597.7608167805606!2d56.2730343!3d25.612863!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef43212fdc278df%3A0x79978d7a546831cc!2sSharjah%20Charity%20International%20-%20Dibba%20Al%20Hisn!5e0!3m2!1sen!2s!4v1718176231156!5m2!1sen!2s"
                      className="rounded-2xl w-full"
                      height="250"
                      allowfullscreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>

          <h2 className={ `text-customgreen  sm:text-4xl flex font-bold py-6 justify-center ` } >
            { t('Al Madam Branch') }
          </h2>

          <div className="relative overflow-x-auto  shadow-md sm:rounded-lg" >
            <Table className="text-sm text-left rtl:text-right ">
              <Table.Header className="text-xs text-white bg-customgreen uppercase  whitespace-nowrap">
                <Table.Row>
                  <Table.HeaderCell className="text-white">{ t('Toll-Free Number') }</Table.HeaderCell>
                  <Table.HeaderCell className="text-white">{ t('Geographic') }</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row className="align-middle">
                  <Table.Cell>80014</Table.Cell>
                  <Table.Cell>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3618.5981017804143!2d55.7758848!3d24.911686899999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef57409aaaaaaab%3A0x9e5e9fdc543fb716!2sSharjah%20Charity%20Association%20Al%20Madam%20Branch!5e0!3m2!1sen!2s!4v1718176143766!5m2!1sen!2s"
                      className="rounded-2xl w-full"
                      height="250"
                      allowfullscreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>

          <h2 className={ `text-customgreen  sm:text-4xl flex font-bold py-6 justify-center ` } >
            { t('Al Dhaid Branch') }{ ' ' }
          </h2>

          <div className="relative overflow-x-auto  shadow-md sm:rounded-lg" >
            <Table className="text-sm text-left rtl:text-right ">
              <Table.Header className="text-xs text-white bg-customgreen uppercase whitespace-nowrap ">
                <Table.Row>
                  <Table.HeaderCell className="text-white">{ t('Toll-Free Number') }</Table.HeaderCell>
                  <Table.HeaderCell className="text-white">{ t('Geographic') }</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row className="align-middle">
                  <Table.Cell>80014</Table.Cell>
                  <Table.Cell>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.259920906536!2d55.8792182!3d25.295469899999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef5be65a655bd75%3A0xb327104c3d506caf!2sSharjah%20Charity%20International%20-%20Dhaid!5e0!3m2!1sen!2s!4v1718175223190!5m2!1sen!2s"
                      height="250"
                      className="rounded-2xl w-full"
                      allowfullscreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>

          <h2 className={ `text-customgreen  sm:text-4xl flex font-bold py-6 justify-center ` } >
            { t('Al Bataeh Office') }
          </h2>

          <div className="relative overflow-x-auto  shadow-md sm:rounded-lg" >
            <Table striped className="text-sm text-left  rtl:text-right ">
              <Table.Header className="text-xs text-white bg-customgreen uppercase  whitespace-nowrap">
                <Table.Row>
                  <Table.HeaderCell className="text-white">{ t('Toll-Free Number') }</Table.HeaderCell>
                  <Table.HeaderCell className="text-white">{ t('Geographic') }</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row className="align-middle">
                  <Table.Cell>80014</Table.Cell>
                  <Table.Cell>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d462083.7324900204!2d55.5525516!3d25.2022391!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef59373e7a130d5%3A0x913f18ac61f8a8ca!2sSharjah%20Charity%20International%20(Albtaaeh%20Branch)!5e0!3m2!1sen!2s!4v1718169969576!5m2!1sen!2s"
                      allowfullscreen=""
                      height="250"
                      className="rounded-2xl w-full"
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
        </section>
      </div>
    </>
  );
};
export default Ouroffices;
